module.exports = __webpack_public_path__ + "static/memorial_card_img1-71f61c669a492a53f6c407c607386c55.jpg";